export default __webpack_public_path__ + "static/media/book.7be91143.png";